import { Component } from '../../../libs/gin-tonic/helpers/compiler';


@Component({ className: 'js-filter' })
export class FilterComponent {
	private selects: NodeListOf<HTMLSelectElement> | null;
	private selectContainer: HTMLElement | null;
	private buttonsContainer: HTMLElement | null;
	private buttonGroup: HTMLElement | null;
	private buttons: HTMLElement[];

	private groupWidth: number;

	constructor(private element: HTMLElement) {
		this.selectContainer = this.element.querySelector('.js-filter-select-container');
		this.selects = this.selectContainer?.querySelectorAll('.js-select');
		this.buttonsContainer = this.element.querySelector('.js-filter-buttons');
		this.buttonGroup = this.buttonsContainer?.querySelector('.js-filter-button-group');

		this.groupWidth = this.buttonGroup?.getBoundingClientRect().width;

		this.selects?.forEach(item => item.addEventListener('change', this.onChange));

		this.buttons = [
			...this.buttonsContainer.querySelectorAll<HTMLElement>('[data-filter]'),
			...this.buttonsContainer.querySelectorAll<HTMLElement>('[data-toggle]'),
			...this.element.querySelectorAll<HTMLElement>('[type="reset"]')
		];

		this.buttons.forEach(button => button.addEventListener('click', this.onButtonClicked.bind(this)))
	}

	onChange = (e) => {
		const filterButton = this.buttonsContainer.querySelector<HTMLElement>('[data-filter=".' + e.currentTarget.value.toLowerCase() + '"]');
		const toggleButton = this.buttonsContainer.querySelector<HTMLElement>('[data-toggle=".' + e.currentTarget.value.toLowerCase() + '"]');
		const button = filterButton != null ? filterButton : toggleButton;
		button?.click();
	}

	onButtonClicked = (e) => {
		if (e.target.type == 'reset') {
			this.selects.forEach(select => {
				select.selectedIndex = null;
			})
		} else {
			const filterString = e.target.getAttribute('data-filter');
			const toggleString = e.target.getAttribute('data-toggle');
			const filter = (filterString != null ? filterString : toggleString)?.replace('.', '');
			this.selects.forEach(select => {
				const option = select.querySelector<HTMLOptionElement>('option[value="' + filter + '"]')
				if (option) {
					option.setAttribute('selected', 'true')
				}
			})
		}
	}
}
